var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-avatar"},[_c('div',{staticClass:"c-avatar__container",class:{ 'c-avatar__container--blue': !_vm.picture },style:(_vm.style)},[(!_vm.picture)?_c('span',{style:(_vm.textSize)},[_vm._v(_vm._s(_vm.shortUsername))]):_c('img',{attrs:{"src":_vm._f("mediaUrl")(_vm.picture),"alt":"avatar"}}),_c('span',{class:{
        online: _vm.status == 'online',
        offline: _vm.status == 'offline'
      }})])])}
var staticRenderFns = []

export { render, staticRenderFns }